export default __webpack_public_path__ + "static/media/brandssliide.95f0a7fd.png";